import { ALL_RECIPES, HIDDEN_RECIPES, RECIPES } from '@constants/subscription';

import { IPet } from '../core/types';

export const getDisabledRecipes = (pet: { allergies: string[]; health_issues: string[] }) => {
  const recipesIDs = ALL_RECIPES.map((recipe) => recipe.id);

  const isDisabledCG =
    pet?.allergies.includes('Rind') ||
    pet?.allergies.includes('Reis') ||
    pet?.health_issues.includes('Pankreatitis');

  const isDisabledGS =
    pet?.allergies.includes('Huhn') || pet?.allergies.includes('Hirse (ist glutenfrei)');

  const isDisabledRT =
    pet?.allergies.includes('Schwein') ||
    pet?.allergies.includes('Kartoffeln') ||
    pet?.allergies.includes('Süßkartoffeln') ||
    pet?.health_issues.includes('Pankreatitis');

  // Wildschmaus (Wild) contains potato (Kartoffeln 33%), so a potato allergy
  // disables it — same trigger Ringeltanz uses for its potato content.
  const isDisabledWS = pet?.allergies.includes('Kartoffeln');

  const allergyDisabled = recipesIDs.filter((recipeId: RECIPES) => {
    switch (recipeId) {
      case RECIPES.CG:
        return isDisabledCG;
      case RECIPES.GS:
        return isDisabledGS;
      case RECIPES.RT:
        return isDisabledRT;
      case RECIPES.WS:
        return isDisabledWS;
      default:
        return false;
    }
  });

  // Hidden recipes (e.g. WS) are always treated as disabled so they get stripped
  // from any current/selected recipes and can never be re-selected in the
  // product-update / recalculate flow.
  return Array.from(new Set([...allergyDisabled, ...HIDDEN_RECIPES]));
};
